import React from 'react';

// Ilustrasi Skala Bristol — dibuat sendiri (SVG), bebas hak cipta.
// Bentuk merepresentasikan karakter tiap tipe (1 keras-terpisah ... 7 cair).
const BROWN = '#9c6b3f';
const BROWN_D = '#7a5230';
const BROWN_L = '#b5854f';

function BristolIllustration({ type, size = 110 }) {
  const t = Number(type);
  const common = { stroke: BROWN_D, strokeWidth: 1.5 };

  const shapes = {
    1: (
      <g fill={BROWN} {...common}>
        {[[30,45],[55,38],[78,48],[42,68],[68,70],[88,66]].map(([x,y],i)=>(
          <ellipse key={i} cx={x} cy={y} rx="11" ry="9" />
        ))}
      </g>
    ),
    2: (
      <g fill={BROWN} {...common}>
        <path d="M22,58 q8,-14 18,-4 q8,-12 18,-2 q9,-11 18,-1 q9,-9 20,2 q-2,16 -16,14 q-10,9 -20,1 q-10,8 -20,0 q-12,2 -18,-10 z" />
      </g>
    ),
    3: (
      <g fill={BROWN} {...common}>
        <rect x="18" y="48" width="84" height="24" rx="12" />
        <g stroke={BROWN_D} strokeWidth="2">
          <line x1="38" y1="50" x2="38" y2="70" />
          <line x1="54" y1="50" x2="54" y2="70" />
          <line x1="70" y1="50" x2="70" y2="70" />
          <line x1="86" y1="50" x2="86" y2="70" />
        </g>
      </g>
    ),
    4: (
      <g fill={BROWN} {...common}>
        <path d="M16,60 q14,-12 30,-6 q18,7 34,0 q14,-6 24,4 q-8,12 -24,8 q-18,-6 -34,0 q-16,5 -30,-6 z" />
      </g>
    ),
    5: (
      <g fill={BROWN_L} {...common}>
        {[[34,46,13,11],[64,44,12,10],[48,66,14,12],[80,62,12,10]].map(([x,y,rx,ry],i)=>(
          <ellipse key={i} cx={x} cy={y} rx={rx} ry={ry} />
        ))}
      </g>
    ),
    6: (
      <g fill={BROWN_L} {...common} strokeWidth="1">
        <path d="M24,52 q6,-10 14,-6 q6,-8 14,-3 q8,-7 16,-2 q9,-5 16,3 q8,2 6,12 q4,9 -6,11 q-6,8 -16,3 q-9,5 -18,0 q-9,4 -16,-3 q-10,-1 -8,-11 q-6,-7 2,-14 z" />
        <g fill={BROWN_D} opacity="0.35">
          {[[40,52],[58,50],[74,56],[50,64],[68,66]].map(([x,y],i)=>(
            <circle key={i} cx={x} cy={y} r="2.5" />
          ))}
        </g>
      </g>
    ),
    7: (
      <g fill={BROWN_L} {...common} strokeWidth="1">
        <path d="M20,58 q10,-12 26,-8 q18,-10 34,-2 q16,-2 22,8 q4,10 -8,14 q-16,8 -34,4 q-18,4 -32,-2 q-12,-4 -8,-14 z" />
        <g fill={BROWN}>
          {[[26,70],[44,74],[66,73],[86,70],[54,40],[74,42]].map(([x,y],i)=>(
            <ellipse key={i} cx={x} cy={y} rx="4" ry="3" />
          ))}
        </g>
      </g>
    ),
  };

  return (
    <svg viewBox="0 0 120 120" width={size} height={size}
      role="img" aria-label={`Ilustrasi Bristol Tipe ${t}`}>
      <rect x="0" y="0" width="120" height="120" rx="10" fill="#faf6f0" />
      {shapes[t] || null}
    </svg>
  );
}

export default BristolIllustration;